import { Button } from '@/components/button';
import { Widget } from '@/components/widget';
import { useListener } from '@/hooks/use-listener';
import { PrinterIcon } from '@heroicons/react/24/outline';
import { useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';

export function HtmlPreviewWidget({ id }: { id: string }) {
  const [html, setHtml] = useState<string>('');
  const printRef = useRef<HTMLIFrameElement>(null);
  const reactToPrint = useReactToPrint({ contentRef: printRef });

  useListener({
    id,
    listenerFn: (data) => {
      setHtml(data?.[0]?.html);
    },
    type: 'preview/html',
  });

  const handlePrintClick = () => {
    reactToPrint();
  };

  return (
    <Widget
      id={id}
      title="HTML Preview"
      toolbar={
        <Button onClick={handlePrintClick}>
          <PrinterIcon className="h-4 w-4" aria-hidden="true" />
        </Button>
      }
      connectable
    >
      <iframe
        ref={printRef}
        srcDoc={`<!DOCTYPE html>
        <html>
          <head>
            <title>Preview</title>
          </head>
          <body>
            ${html}
          </body>
        </html>`}
        className="h-[50rem] w-full border-none print:h-full print:m-10"
        title="HTML Preview"
      />
    </Widget>
  );
}
